import classNames from "classnames/bind";
import style from "./ConfigAi.module.css";
import { Col, Row } from "../../../../components";
import { useEffect, useState } from "react";
import TabBar from "./TabBar";
import ConfigValue from "./ConfigValue";
import ConfigObject from "./ConfigObject";

const cx = classNames.bind(style);

function ConfigAi({ label, codeService, config }) {
    const [tabActive, setTabActive] = useState(0)
    useEffect(() => {
        setTabActive(0)
    }, [codeService])
    return (
        <>
            <TabBar active={tabActive} handleChose={(data) => setTabActive(data)} serviceCode={codeService} />
            {tabActive === 0 && <ConfigValue label={label} codeService={codeService} config={config}/>}
            {tabActive === 1 && <ConfigObject nameService={label} />}

        </>
    )
}


export default ConfigAi;